<template>
  <section>
    <el-dialog title="添加子商品档案" :visible.sync="visible" width="70%">
      <div class="mod-block">
        <el-form ref="form" :model="form" label-width="80px" size="mini" class="mod-form">
          <div class="groups">
            <el-form-item label="子商品编码" prop="childItem">
              <el-input v-model="form.childItem" disabled></el-input>
            </el-form-item>
            <el-form-item label="子商品名称" prop="childItemDesc">
              <el-input v-model="form.childItemDesc" disabled></el-input>
            </el-form-item>
            <!-- <el-form-item label="区域ID" required>
              <el-input v-model="area" disabled></el-input>
            </el-form-item> -->
            <el-form-item label="商品条码" prop="barcode" :rules="[{validator: $validate.required, noRequired: form.barcodeType}]" :required="!form.barcodeType">
              <el-input v-model="form.barcode" @input="handleBarcode" type="number" :disabled="!!form.barcodeType"></el-input>
            </el-form-item>
            <el-form-item label="编码类型" prop="barcodeType" :rules="[{validator: $validate.required, noRequired: form.barcode}]" :required="!form.barcode">
              <el-select v-model="form.barcodeType" @change="barcodeTypeChange" :disabled="!!form.barcode">
                <el-option value="Y" label="自编码">自编码</el-option>
                <el-option value="N" label="称重码">称重码</el-option>
              </el-select>
            </el-form-item>
          </div>
          <h3 class="title">差异组值</h3>
          <div class="groups" v-for="(item, index) in form.formDiff" :key="index" v-if="item.v1">
            <el-form-item label="差异组">
              <el-select v-model="item.v2" disabled>
                <el-option :value="item2.diffGroupId" :label="item2.diffGroupDesc" v-for="(item2, index2) in Object.values(item.map2)" :key="index2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="差异值" :prop="'formDiff.'+index+'.v3'" :rules="[{ required: true, message: '请选择差异值'}]">
              <el-select v-model="item.v3" filterable>
                <el-option :value="item2.diffType" :label="item2.diffDesc" v-for="(item2, index2) in Object.values(item.map3)" :key="index2"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="save">保存{{isEdit ? '' : '并添加下一个'}}</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
  export default {
    props: ['dataList', 'selectIndex'],
    inject: ['getMod'],
    data () {
      return {
        visible: false,
        form: {
          barcode: '',
          barcodeType: '',
          childItem: '',
          childItemDesc: '',
          formDiff: []
        }
      }
    },
    computed: {
      isEdit () {
        return this.selectIndex != 'null'
      }
    },
    watch: {
      visible (val) {
        if (val) {
          let $basicInfo = this.getMod('basicInfo')
        } else {
          // this.$refs.form.resetFields()
        }
      }
    },
    methods: {
      cloneObj (obj) {
        return JSON.parse(JSON.stringify(obj))
      },
      show () {
        this.$nextTick(() => {
          this.getDiffAr()
        })
      },
      emptyForm () {
        this.form.barcode = ''
        this.form.barcodeType = ''
        this.form.childItem = ''
        this.form.childItemDesc = ''
        // 清空三级数据
        this.form.formDiff.forEach(item => {
          item.v3 = ''
        })
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.clearValidate()
        })
      },
      getDiffAr () {
        this.emptyForm()
        let $itemDiffModel = this.getMod('itemDiffModel')
        $itemDiffModel.$refs.form.validate(valid => {
          if (valid) {
            let ar = this.cloneObj($itemDiffModel.formDiff.list)
            this.form.formDiff = []
            ar.forEach((item, index) => {
              if (item.v1) {
                let obj = {...item}
                if (!this.isEdit) {
                  obj.v3 = ''
                }
                this.form.formDiff.push(obj)
              }
            })
            this.visible = true
          } else {
            this.$message.error('请先完善【diff值组】信息')
          }
        })
      },
      handleBarcode (val) {
        this.form.barcodeType = ''
      },
      barcodeTypeChange () {
        this.form.barcode = ''
      },
      editROw (obj) {
        this.form = Object.assign({}, this.cloneObj(obj))
        this.visible = true
      },
      validateRepeat () {
        let ar1 = this.form.formDiff.map(item => item.v3).sort()
        return this.dataList.find((item, index) => {
          // 过滤当前编辑的数据
          if (this.isEdit && this.selectIndex == index) {
            return false
          } else {
            let ar2 = item.formDiff.map(item => item.v3).sort()
            return ar2.join(',') === ar1.join(',')
          }
        })
      },
      save () {
        this.$refs.form.validate(valid => {
          if (valid) {
            // diff组合不能重复
            if (this.validateRepeat()) {
              this.$message.warning('已存在同一差异值数据!')
              return
            }
            this.$message.success('操作成功')
            this.$emit('sure', {
              list: this.cloneObj(this.form),
              formDiff: this.cloneObj(this.form.formDiff)
            })
            if (this.isEdit) {
              this.visible = false
            } else {
              this.emptyForm()
            }
          }
        })
      }
    },
    mounted () {}
  }
</script>
<style lang="scss" scoped>
  .mod-block {
    background-color: #fff;
    border-radius: 5px;
    padding: 12px 10px 0px;
    overflow: hidden;
    margin-bottom: 10px;
    .title {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding-bottom: 10px;
      &::before {
        display: inline-block;
        content: "";
        height: 1em;
        border: 1px solid #3366ff;
        margin-right: 2px;
      }
    }
    .groups {
      overflow: hidden;
    }
  }
  .mod-form {
    .el-form-item {
      float: left;
      width: 190px;
      margin-bottom: 12px!important;
      border: 1px solid #ddd;
      padding: 3px;
      border-radius: 3px;
      margin-right: 10px;
    }
    /deep/ .label-text .el-form-item__label {
      line-height: 14px;
    }
    /deep/ .el-form-item__label {
      text-align: center;
      padding: 0 0 0 0;
    }
    /deep/ .el-input__inner {
      width: 100px;
    }
    /deep/ .el-form-item__content {
      font-size: 12px;
    }
    .mod-tag {
      background: #8400FF;
      color: #fff;
      border-radius: 4px;
      font-size: 12px;
      font-style: normal;
      padding: 2px;
    }
    .btns {
      float: left;
      padding-top: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/newProductApplication/newpool/add/diff/sub-commodity-add.vue